export const getDefaultValues = (details) => ({
  SubscribePackageTypeLable: details?.SubscribePackageTypeLable || '',
});
